import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  ICalenderSepratorStore,
} from '../../mobx-store/storeInterfaces/calenderSepratorInterface';

interface IProps extends WithSnackbarProps {
  calenderSepratorStore: ICalenderSepratorStore;
  history: any;
}

@inject('calenderSepratorStore')
@observer
class calenderSeprator extends Component<IProps> {
  addButton: any;

  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title = 'calender Seprator Management';

  constructor(props: IProps) {
    super(props);
  }

  handleTableButtonCellClicked = (index: number) => {
    const {
      history, calenderSepratorStore,
    } = this.props;
    history.push(`/events/calender/separator/${calenderSepratorStore.calenderSepratorList[index].separatorId}/edit`);
  };

  handleAdd = (): void => {
    this.props.history.push('/events/calender/separator/new');
  };

  getAddCalenderSepratorButton = () => ({
    title: 'Add',
    onAdd: this.handleAdd,
  });

  getCalenderSepratorTableHeader = () => [
    {
      title: 'Calender Seprator Title',
    },
    {
      title: 'Image',
    },
    {
      title: 'Edit',
    },
  ];

  getCalenderSepratorTableData = () => this.props.calenderSepratorStore.calenderSepratorList
    .map((calenderSeprator) => ({
      ...calenderSeprator, edit: 'Edit',
    }));

  getCalenderSepratorTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'Image',
      key: 'imageURL',
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  componentDidMount() {
    this.props.calenderSepratorStore.getCalenderSeprator();
  }

  render() {
    this.addButton = this.getAddCalenderSepratorButton();
    this.tableHeader = this.getCalenderSepratorTableHeader();
    this.tableData = this.getCalenderSepratorTableData();
    this.tableCellTypes = this.getCalenderSepratorTableCellTypes();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage="There are no calender Seprator yet. Please add a new now"
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            this.props.calenderSepratorStore.getCalendarSeperatorRequestStatus
          ]}
        />
      </div>
    );
  }
}

export default calenderSeprator;
